import React, { useState } from 'react';
import useFetchSingleWellColorAnalysis from '../../Hooks/Analysis/useFetchSingleWellColorAnalysis';
import { useParams } from 'react-router-dom';
import Spinner from '../../common/Spinner';
import { usePlateWellActions, useAnalysisResults, useTabValue } from '../../../store/plateWellStore';


const SingleWellAnalysis = () => {
    const { plate_uuid } = useParams();
    let formattedData = [];
    const [channels, setChannels] = useState([]);
    const analysisResults = useAnalysisResults();
    const { setAnalysisResults } = usePlateWellActions();
    const tabValue = useTabValue();
    const { data, error, isError, isSuccess, isFetching } = useFetchSingleWellColorAnalysis(plate_uuid, {

        onSuccess: (data) => {
            const singleWellData = JSON.parse(data?.data?.body);
            setChannels(singleWellData?.Channels);
            formattedData = transformSingleWellData(singleWellData);
            setAnalysisResults(formattedData);
        },
        onError: (error) => {
            console.log(error);
        }

    });

    // function to transform the API data to render in the UI. This is specific to single well and cannot be a generic function since 
    // API generates data differently for each analysis - thus including it in the component itself. 

    function transformSingleWellData(singleWellData) {

        //if (colorData?.isSuccess && singleWellData?.Well_Data?.data?.length > 0) {
        const wellData = singleWellData?.Well_Data?.data;
        const plateData = singleWellData?.Plate_Data;
        const channels = singleWellData?.Channels; // thes tate update to channels is still in progress so retrieve the channel data here 

        const formattedData = wellData?.map((well, index) => {
            const channelData = {};
            channels.forEach(channel => {
                channelData[channel] = {
                    Average: well[channel]?.Average?.Value && !isNaN(well[channel].Average.Value) ?
                        Number(well[channel].Average.Value.toFixed(2)) : 'N/A',
                    CV: well[channel]?.CV?.Value && !isNaN(well[channel].CV.Value) ?
                        Number(well[channel].CV.Value.toFixed(2)) : 'N/A',
                    Count: well[channel]?.Count?.Value && !isNaN(well[channel].Count.Value) ?
                        Number(well[channel].Count.Value.toFixed(2)) : 'N/A'
                }
            });
            return {
                Well: well?.Well?.Value,
                ...channelData // append channel data to each well
            }
        });
        // Add the 'Mean' Row (Dynamic Mean Calculation)
        const meanRow = { Well: 'Mean' };
        channels.forEach((channel) => {
            meanRow[channel] = {
                Average: plateData[channel]?.Average?.Value && !isNaN(plateData[channel].Average.Value)
                    ? plateData[channel].Average.Value.toFixed(2)
                    : 'N/A',
                CV: plateData[channel]?.CV?.Value && !isNaN(plateData[channel].CV.Value) ?
                    Number(plateData[channel].CV.Value.toFixed(2)) : 'N/A',
                Count: plateData[channel]?.Count?.Value && !isNaN(plateData[channel].Count.Value) ?
                    Number(plateData[channel].Count.Value.toFixed(2)) : 'N/A'
            }
        });
        formattedData.unshift(meanRow);
        return formattedData;
    }


    return (
        <>
            {console.log({ analysisResults })}
            {console.log({ channels })}
            {console.log({ tabValue })}
            {analysisResults && channels?.length > 0 ? (
                <div className="border-2 border-solid rounded-sm border-custom-green overflow-x-auto overflow-y-scroll h-full">
                    <table className="w-max">
                        <thead>
                            <tr className="text-sm text-center">
                                <th className="text-sm text-center">Well</th>
                                {channels?.map((channel, index) => (
                                    <th colSpan="3" key={channel} className={`
                ${index % 2 === 0 ? 'bg-blue-100' : 'bg-green-100'}  {/* Alternate colors */}
              `}>{channel}</th>
                                ))}
                            </tr>
                            <tr className="text-sm text-center">
                                <th /> {/* Empty first <th> for alignment with the Well cell*/}
                                {channels.map((channel, index) => (
                                    <React.Fragment key={channel}>
                                        <th className={`bg-blue-100 ${index % 2 === 1 ? 'bg-green-100' : ''}`}>Average</th>
                                        <th className={`bg-blue-100 ${index % 2 === 1 ? 'bg-green-100' : ''}`}>CV</th>
                                        <th className={`bg-blue-100 ${index % 2 === 1 ? 'bg-green-100' : ''}`}>Count</th>
                                    </React.Fragment>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {analysisResults?.map((row) => (
                                <tr className='text-sm text-left' key={row.Well}>
                                    <td className="px-4 py-3 border rounded-md">{row.Well}</td>
                                    {channels.map((channel, index) => (
                                        <React.Fragment key={`${row.Well}-${channel}`}>
                                            <td className={`bg-blue-100 px-4 py-3 border rounded-md ${index % 2 === 1 ? 'bg-green-100' : ''}`}>{row[channel] ? row[channel]?.Average : 'N/A'}</td>
                                            <td className={`bg-blue-100 px-4 py-3 border rounded-md ${index % 2 === 1 ? 'bg-green-100' : ''}`}>{row[channel] ? row[channel]?.CV : 'N/A'}</td>
                                            <td className={`bg-blue-100 px-4 py-3 border rounded-md ${index % 2 === 1 ? 'bg-green-100' : ''}`}>{row[channel] ? row[channel].Count : 'N/A'}</td>
                                        </React.Fragment>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ) : isFetching ? <Spinner text="Fetching Data..." /> : isError
                ? <p>API Error. Pls check back later</p> : <p>No Data Available at this time</p>}
        </>
    );

};

export default SingleWellAnalysis;